var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 16,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    height: "111.7%",
    width: "111.7%",
    x: "-5.8%",
    y: "-4.2%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.199473505 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    height: "117.5%",
    width: "129.2%",
    x: "-14.6%",
    y: "-6.2%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.204257246 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#c)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00aded",
    fillRule: "evenodd",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    fillRule: "evenodd",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15,
    r: 14.5,
    stroke: "#000",
    strokeOpacity: 0.097
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    filter: "url(#d)",
    transform: "translate(10 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.09684034 17.6030476.00184735-.0042857 3.18785561-7.61590477-3.18970296-7.61533332 5.88557851 7.61533332-5.88159211 7.61495237zm11.77631026 0-.0039864-.0052381-5.88149493-7.61495237 5.88548133-7.61533332-3.18970303 7.61533332 3.18795283 7.61590477z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.98494683 9.98409523v5.30590477l-5.88956493 2.31 5.88956493-7.62038097v-5.30590474l5.88956497-2.31z",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.98494683 15.29v4.6509524l-5.88956493-2.3437143 5.88956493-2.3147619v-5.29838097l-5.88956493-7.62038094 5.88956493 2.31v-4.65085715l5.88956497 2.34361905-5.88956497 2.31485714v5.2982857l5.88956497 7.62038097z",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.0953819 2.36647619 5.88956493-2.34361905v4.65847619zm11.7791299 15.23076191-5.88956497 2.3437143v-4.6584762z",
    fillOpacity: 0.145
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.84151310c6332a08ab85426581a3bb65.svg";
export { ForwardRef as ReactComponent };